import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "providers/Auth";
import { useDebouncedValue } from "shared/hooks/use-debounced-value";
import { Statement } from "./types";
import { PaginatedResponse } from "shared/types";
import { instance } from "api/apiBase";

export const useBillingController = () => {
  const { partner: currentPartner } = useAuthContext();
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery] = useDebouncedValue(searchQuery, 500);
  const [statementPage, setStatementPage] = useState(1);

  const statementsQuery = useQuery({
    queryKey: ["STATEMENTS", debouncedSearchQuery, statementPage],
    queryFn: () =>
      instance
        .get<PaginatedResponse<Statement>>(`/portal/v1/statements/`, {
          params: {
            per_page: 10,
            page: statementPage,
            search: debouncedSearchQuery
          }
        })
        .then(({ data }) => data)
  });

  const statementUpcomingQuery = useQuery({
    queryKey: ["STATEMENT_UPCOMING"],
    queryFn: () =>
      instance.get(`/portal/v1/statements/upcoming`).then(({ data }) => data)
  });

  return {
    statements: statementsQuery.data,
    statementsIsLoading: statementsQuery.isFetching,
    payoutAccount: currentPartner?.payout_bank_account,
    invoiceAccount: currentPartner?.invoice_bank_account,
    statementUpcoming: statementUpcomingQuery.data,
    statementUpcomingIsLoading: statementUpcomingQuery.isLoading,
    setStatementPage,
    searchQuery,
    setSearchQuery
  };
};
